import { Component, inject } from '@angular/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { DriftsMeddelelserService } from './driftsmeddelelser.service';
import { Button } from 'primeng/button';
import { DriftsmeddelelserListComponent } from './driftsmeddelelser-list/driftsmeddelelser-list.component';
import { DriftmeddelelserDetailComponent } from './driftmeddelelser-detail/driftmeddelelser-detail.component';

@Component({
  selector: 'app-driftsmeddelelser',
  imports: [
    Button,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    DriftsmeddelelserListComponent,
    DriftmeddelelserDetailComponent,
  ],
  templateUrl: './driftsmeddelelser.component.html',
  styleUrl: './driftsmeddelelser.component.css',
})
export class DriftsmeddelelserComponent {
  driftsMeddelelserService = inject(DriftsMeddelelserService);
}
